import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	open: false,
	message: '',
	severity: '',
	duration: 0,
};

const notificationBarSlice = createSlice({
	name: 'notificationBar',
	initialState,
	reducers: {
		displaySuccessMessage: (state, action) => {
			state.open = true;
			state.severity = 'success';
			state.message = action.payload;
			state.duration = 4000;
		},
		displayWarningMessage: (state, action) => {
			state.open = true;
			state.severity = 'warning';
			state.message = action.payload;
			state.duration = 4000;
		},
		displayErrorMessage: (state, action) => {
			state.open = true;
			state.severity = 'error';
			state.message = action.payload;
			state.duration = 4000;
		},
		displayInfoMessage: (state, action) => {
			state.open = true;
			state.severity = 'info';
			state.message = action.payload;
			state.duration = 3000;
		},
		hideNotificationBar: (state) => {
			state.open = false;
			state.severity = '';
			state.message = '';
			state.duration = 0;
		},
	},
});
export const showNotificationBarState = (state) => {
	return state.notificationBar;
};
export const {
	displaySuccessMessage,
	displayWarningMessage,
	displayErrorMessage,
	displayInfoMessage,
	hideNotificationBar,
} = notificationBarSlice.actions;

export default notificationBarSlice.reducer;
